import { render } from "./LogoImg.vue?vue&type=template&id=52209a94&scoped=true"
const script = {}

import "./LogoImg.vue?vue&type=style&index=0&id=52209a94&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52209a94"]])

export default __exports__